import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Menu, Typography } from 'antd';
import styles from './index.module.less';
import { useShallow } from 'zustand/react/shallow';
import useStore from '@/pages/documentCompile/store/useStore';
import { DocumentFileType, DocumentSettingType } from '@/pages/documentCompile/type';
import { ToolBarType } from '../../type';
import { isShowDomainConfigByFileName } from '@/pages/documentCompile/utils/file';

const { Sider } = Layout;
const { Title } = Typography;

interface LeftToolbarProps {
  children?: React.ReactNode;
}

const LeftToolbar: React.FC<LeftToolbarProps> = ({ children }) => {
  const setStoreState = useStore.setState
  const { documnetSettingType, selectedToolBar, documentSettingProjectData } = useStore(
    useShallow((s) => ({
      documnetSettingType: s.documnetSettingType,
      selectedToolBar: s.selectedToolBar,
      documentSettingProjectData: s.documentSettingProjectData,
    }))
  );
  // console.log("documentSettingProjectData2", documentSettingProjectData)
  const [selectedKey, setSelectedKey] = useState('projectInfo');

  // 工程量指标模板菜单项配置
  const engineeringQuantityMenuItems = [
    {
      key: ToolBarType.PACKAGE_INFO,
      label: '资料目录',
    },
    {
      key: ToolBarType.PROJECT_INFO,
      label: '项目信息',
    },
    {
      key: ToolBarType.DOCUMENT_INFO,
      label: '文档信息',
    },
    {
      key: ToolBarType.PROJECT_FIELD_DOMAIN,
      label: '字段域',
    },
  ];

  const templateMenuItems = [
    {
      key: ToolBarType.FIELD_DOMAIN,
      label: '字段域',
    },
  ]

  const menuItems = useMemo(() => {
    if (documnetSettingType === DocumentSettingType.DOCUMENT_TEMPLATE) {
      return templateMenuItems
    }
    // const fileType = documentSettingProjectData.documentDetail?.type || documentSettingProjectData.documentDetail?.docType
    const fileName = documentSettingProjectData.documentDetail?.fileName || documentSettingProjectData.documentDetail?.documentName || documentSettingProjectData.documentDetail?.name
    const isJuan = documentSettingProjectData.documentDetail?.isJuan
    // 卷不展示域配置
    if (isJuan) {
      return engineeringQuantityMenuItems.filter(item => [ToolBarType.PACKAGE_INFO].includes(item.key))
    }
    if (!isShowDomainConfigByFileName(fileName)) {
      // 根据类型 隐藏 文档信息 和 字段域
      return engineeringQuantityMenuItems.filter(item => ![ToolBarType.PROJECT_FIELD_DOMAIN, ToolBarType.DOCUMENT_INFO].includes(item.key))
    }
    return engineeringQuantityMenuItems
  }, [documnetSettingType, documentSettingProjectData])

  const handleSelect = (e: any) => {
    setSelectedKey(e.key)
    setStoreState({
      selectedToolBar: e.key,
    })
  }

  useEffect(() => {
    setSelectedKey(menuItems[0].key)
  }, [menuItems])

  return (
    <Sider width={40} className={styles.leftToolbar}>
      <div className={styles.toolbarContent}>
        <Menu
          mode="inline"
          selectedKeys={[selectedToolBar]}
          items={menuItems}
          onSelect={handleSelect}
          className={styles.menu}
        />
      </div>
    </Sider>
  );
};

export default LeftToolbar; 